/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateThreadRequest
 */
export interface CreateThreadRequest {
    /**
     * The <code>id</code> of an existing record in the forum_categories table.
     * @type {string}
     * @memberof CreateThreadRequest
     */
    forumCategoryId: string;
    /**
     * The <code>id</code> of an existing record in the cars table.
     * @type {number}
     * @memberof CreateThreadRequest
     */
    carId?: number | null;
    /**
     * Must not be greater than 255 characters.
     * @type {string}
     * @memberof CreateThreadRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateThreadRequest
     */
    body: string;
}

/**
 * Check if a given object implements the CreateThreadRequest interface.
 */
export function instanceOfCreateThreadRequest(value: object): value is CreateThreadRequest {
    if (!('forumCategoryId' in value) || value['forumCategoryId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function CreateThreadRequestFromJSON(json: any): CreateThreadRequest {
    return CreateThreadRequestFromJSONTyped(json, false);
}

export function CreateThreadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateThreadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'forumCategoryId': json['forum_category_id'],
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'title': json['title'],
        'body': json['body'],
    };
}

export function CreateThreadRequestToJSON(json: any): CreateThreadRequest {
    return CreateThreadRequestToJSONTyped(json, false);
}

export function CreateThreadRequestToJSONTyped(value?: CreateThreadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'forum_category_id': value['forumCategoryId'],
        'car_id': value['carId'],
        'title': value['title'],
        'body': value['body'],
    };
}

